/// <reference path="../app.js" />
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { LogoutUser, LoginUser, SetAppliedJobs, UpdateUser } from "../actions";
import { useIdleTimer } from "react-idle-timer";
import authConfig from "../config/auth.json";
import { AES, enc } from "crypto-js";
import { GlobalApiErrorHandler } from "../shared/helpers";
import { MsgBox } from "../shared/custom-ant-d";
import JobsUrl from "../reducers/JobsUrl";
import { reqPostRetrieveCandidateProfile, reqPostLogout } from "../axios/api";

export const AuthMiddleware = (props) => {
  const Auth = useSelector((state) => state.Auth);
  const history = useHistory();
  const dispatch = useDispatch();

  const milsec = authConfig.sessionTimeoutMins * 60000; // multiply mins to 60000 to get mil sec

  const exemptedPath = [
    "/register",
    "/passwordreset",
    "/forgot-password",
    "/login",
    "/apply",
    "/job-item",
    //"/job-apply",
    //"/profile",
    "/new-jobs",
  ];

  //middleware for authentication
  useEffect(() => {
    if (
      !Auth.isLoggedIn &&
      !(
        sessionStorage.getItem("candidate") !== undefined &&
        sessionStorage.getItem("candidate")
      )
    ) {
      let arrStr = history.location.pathname.split("/");
      if (arrStr.length > 1) {
        if (arrStr[1] === "job-apply") {
          return redirectToJobApplyOnLogin();
        } else if (arrStr[1] === "offers") {
          return redirectToOfferOnLogin();
        } else if (arrStr[1] === "employee-handbook") {
          return redirectToHandBookOnLogin();
        }
        if (!exemptedPath.includes("/" + arrStr[1])) {
          return history.push("/");
        }
      }
    } else if (
      !Auth.isLoggedIn &&
      sessionStorage.getItem("candidate") !== undefined &&
      sessionStorage.getItem("candidate")
    ) {
      const decrypted = AES.decrypt(
        sessionStorage.getItem("candidate"),
        "IQORCAREERS"
      );
      const decryptedCandidateObj = decrypted.toString(enc.Utf8);
      dispatch(LoginUser(JSON.parse(decryptedCandidateObj)));
    }
  }, [Auth]);

  useEffect(() => {
    if (props.tokenLoaded) {
      if (
        sessionStorage.getItem("candidate") !== undefined &&
        sessionStorage.getItem("candidate")
      ) {
        const decrypted = AES.decrypt(
          sessionStorage.getItem("candidate"),
          "IQORCAREERS"
        );
        const decryptedCandidateObj = decrypted.toString(enc.Utf8);
        loginByCandidateObj(decryptedCandidateObj);
      }
    }
  }, [props.tokenLoaded]);

  const redirectToJobApplyOnLogin = () => {
    let searchArr = null;
    let queryID = 0;

    if (history.location.search.includes("?jobPostingID=")) {
      searchArr = history.location.search.split("?jobPostingID=");

      if (searchArr.length >= 2) {
        queryID = parseInt(searchArr[1]);
      }

      return history.push({
        pathname: "/login",
        state: {
          prevPath: "/job-apply",
          search: "?jobPostingID=" + queryID,
          jobDetails: null,
        },
      });
    } else if (
      history.location.search.toLocaleLowerCase().includes("?applicationid=")
    ) {
      searchArr = history.location.search
        .toLocaleLowerCase()
        .split("?applicationid=");

      if (searchArr.length >= 2) {
        queryID = parseInt(searchArr[1]);
      }

      return history.push({
        pathname: "/login",
        state: {
          prevPath: "/job-apply",
          search: "?applicationID=" + queryID,
          jobDetails: null,
        },
      });
    }

    //return history.push("/jobs");
    return (window.location.href = JobsUrl + "/jobs");
  };

  const redirectToOfferOnLogin = () => {
    let searchArr = null;
    let offerID = 0;

    if (history.location.search.includes("?offerID=")) {
      searchArr = history.location.search.split("?offerID=");

      if (searchArr.length >= 2) {
        offerID = parseInt(searchArr[1]);
      }

      return history.push({
        pathname: "/login",
        state: {
          prevPath: "/offers",
          search: "?offerID=" + offerID,
          jobDetails: null,
        },
      });
    }

    //return history.push("/jobs");
    return (window.location.href = JobsUrl + "/jobs");
  };

  const redirectToHandBookOnLogin = () => {
    let searchArr = null;
    let CountryCode = null;

    if (history.location.search.includes("?countryCode=")) {
      searchArr = history.location.search.split("?countryCode=");
      debugger;
      if (searchArr.length >= 2) {
        CountryCode = searchArr[1];
      }

      return history.push({
        pathname: "/login",
        state: {
          prevPath: "/employee-handbook",
          search: "?countryCode=" + CountryCode,
          jobDetails: null,
        },
      });
    }

    return (window.location.href = JobsUrl + "/jobs");
  };

  const loginByCandidateObj = (candidate) => {
    var formData = JSON.parse(candidate);
    reqPostRetrieveCandidateProfile(formData)
      .then((res) => {
        if (res.data.isSuccess) {
          dispatch(
            LoginUser({
              candidateID: res.data.candidateObj.candidateID,
              personalEmail: res.data.candidateObj.personalEmail,
              firstName: res.data.candidateObj.firstName,
              middleName: res.data.candidateObj.middleName,
              lastName: res.data.candidateObj.lastName,
              currentTitle: "",
              currentCompany: "",
              primaryPhone: res.data.candidateObj.primaryPhone,
              secondaryPhone: res.data.candidateObj.secondaryPhone,
              preferedContactMethodID:
                res.data.candidateObj.preferedContactMethodID,
              homeAddress1: res.data.candidateObj.homeAddress1,
              homeAddress2: res.data.candidateObj.homeAddress2,
              homeAddress3: res.data.candidateObj.homeAddress3,
              city: res.data.candidateObj.city,
              province: "",
              stateID: res.data.candidateObj.stateID,
              zipCode: res.data.candidateObj.zipCode,
              countryID: res.data.candidateObj.countryID,
              countryName: res.data.candidateObj.countryName,
              candidateCoverLetterUniqueID:
                res.data.candidateObj.candidateCoverLetterUniqueID,
              candidateResumeUniqueID:
                res.data.candidateObj.candidateResumeUniqueID,
              candidateCoverLetterFileFriendlyName:
                res.data.candidateObj.candidateCoverLetterFileFriendlyName,
              candidateResumeFileFriendlyName:
                res.data.candidateObj.candidateResumeFileFriendlyName,
              highestLevelOfEducationID:
                res.data.candidateObj.highestLevelOfEducationID,
            })
          );

          dispatch(SetAppliedJobs(res.data.candidateObj.applicationList));
        } else {
          MsgBox({
            type: "error",
            message: "Error",
            description: res.data.errorMessage,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        GlobalApiErrorHandler({ errors: err.response.data.errors });
      });
  };

  const handleOnIdle = (event) => {
    if (Auth.isLoggedIn) {
      sessionStorage.removeItem("candidate");
      dispatch(LogoutUser());
      MsgBox({
        type: "error",
        message: "Session Timeout",
        description: "Session Time out",
      });
      history.push("/");
      reqPostLogout();
    }
  };

  const { getRemainingTime, getLastActiveTime } = useIdleTimer({
    timeout: milsec,
    onIdle: handleOnIdle,
    //onActive: handleOnActive,
    //onAction: handleOnAction,
    debounce: 500,
  });

  return <></>;
};
